var render, staticRenderFns
import script from "./VCheckbox.vue?vue&type=script&lang=ts"
export * from "./VCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=bea2434a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea2434a",
  null
  
)

export default component.exports